import { cloneDeep } from 'lodash-es';
import React, { useEffect, useMemo } from 'react';
import { convertFeetRangeToCm } from './SizeChartDataProcessing';
import { IHeightSelection } from './sizeChartTypes';

const HeightSelection = ({
  data,
  systemOfMeasurements,
  usersHeight,
  setHeight,
}: {
  data: IHeightSelection;
  systemOfMeasurements: string;
  usersHeight: string | undefined;
  setHeight: (height: string) => void;
}) => {
  const enhancedData = useMemo(() => {
    const obj = cloneDeep(data);
    Object.entries(obj).forEach((entry) => {
      const [key, height] = entry;
      obj[key as keyof IHeightSelection].valueInCm = convertFeetRangeToCm(height.value);
    });
    return obj;
  }, [data]);

  useEffect(() => {
    if (!usersHeight) {
      const defaultHeight = Object.keys(enhancedData)[0];
      if (defaultHeight) setHeight(defaultHeight);
    }
    return () => {};
  }, [enhancedData, usersHeight, setHeight]);

  return (
    <div className={`height-selection`}>
      <p className="small-p" tabIndex={0}>
        Select a height to understand the length fit:
      </p>
      <div className="height-buttons-wrapper d-flex">
        {Object.entries(enhancedData).map((entry) => {
          const [key, height] = entry;
          return (
            <button
              key={key}
              data-testid={`size-guide-users-height-${key}`}
              className={`height-button ${usersHeight === key ? 'active' : ''}`}
              onClick={() => {
                setHeight(key);
              }}
            >
              {systemOfMeasurements === 'imperial' ? height.value : height.valueInCm}
            </button>
          );
        })}
      </div>
      {usersHeight && (
        <div className="length-fit" tabIndex={0}>
          <p className="length-fit-description">
            Full length: <span>{enhancedData[usersHeight as keyof IHeightSelection].full}</span>
          </p>
          <p className="length-fit-description">
            7/8 Length: <span>{enhancedData[usersHeight as keyof IHeightSelection]['7_8']}</span>
          </p>
          <p className="length-fit-description">
            Capri: <span>{enhancedData[usersHeight as keyof IHeightSelection].capri}</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default HeightSelection;
